// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
  cryptoSecretKey: 'q0vTI7Ku1Z9!efHn',
  cryptoSecretIv: 'a3yKL6Ko7X2?gKnL',
  imagesRxArcoSnifferUrl: 'https://gtp-coll.portolivorno2000.it/images-rx-arco-sniffer/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
